import _ from "lodash";

import {
  Component,
} from "react";
import {
  Col,
  Row,
} from "react-bootstrap";
import {
  Panel,
  Pill,
  Tooltip,
} from "CommonComponents/bricks";
import {
  Link,
} from "react-router-dom";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
} from "App/constants";

export default class DashbordWidgetWorkflow extends Component {
  constructor() {
    super();
    this.state = { zeigeInfos: {} };
    this.schritte = [];
  }

  openDocLink(link) {
    if (link) {
      window.open(link);
    }
  }

  render = () => {
    const { AntragstellerModus } = this.props;
    const { zeigeInfos } = this.state;

    const modus = ANTRAGSTELLERMODUS[AntragstellerModus];

    const nextPos = () => {
      return _.max(_.map(this.schritte, x => x.pos)) + 1;
    };

    this.schritte = [
      {
        pos: 1,
        titel: "Persönliche Angaben erfassen",
        info: "Das System zeigt Ihnen hier auf der Startseite an, wenn alle Daten vollständig erfasst sind.",
      },
      {
        pos: 2,
        titel: modus.labelButtonAntragStellen || "Antrag stellen",
        info: `Im Menüpunkt "vorgesehene Maßnahmen" oder hier auf der Startseite unter "${ modus.labelAntragstellung }" finden Sie die Beschreibung der für Sie vorgesehenen Stelle. Wenn Sie sich entscheiden, hierzu den Antrag zu erstellen, werden automatisch Ihre persönlichen Angaben in den Antrag übernommen. Die Ergänzung und Änderung der persönlichen Angaben ist bis zum Einreichen des Antrags beim Personaldezernat möglich.`,
      },
      {
        pos: 3,
        titel: "Antrag einreichen",
        info: "Sind alle Angaben vollständig erfasst (es gibt eine Prüffunktion im Antrag), können Sie den Antrag einreichen.",
      },
      {
        pos: 4,
        titel: `Antragsprüfung durch ${ modus.labelPrüfungsstelleMitArtikel || "das Personaldezernat" }`,
        info: `Mit dem Einreichen des Antrags erhält ${ modus.labelPrüfungsstelleMitArtikel || "das Personaldezernat" } automatisch die Information, dass Ihre Unterlagen zur Prüfung vorliegen. Die Prüfung kann unter Umständen mehrere Wochen in Anspruch nehmen. Sollten noch Unterlagen oder bestimmte Angaben fehlen, kann ${ modus.labelPrüfungsstelleMitArtikel || "das Personaldezernat" } Ihnen den Antrag zur Überarbeitung zurückreichen. Sie werden per E-Mail hierüber benachrichtigt.`,
      },
    ];

    if ([ASTMODUSKEY.Hilfskraft, ASTMODUSKEY.Tarif, ASTMODUSKEY.WerkPrivat].includes(AntragstellerModus)) {
      // Diesen Schritt nicht bei Lehraufträgen ausgeben
      if (AntragstellerModus === ASTMODUSKEY.Tarif) {
        this.schritte.push(
          {
            pos: nextPos(),
            titel: `${ modus.labelVertrag } in 2-facher Ausfertigung erhalten`,
            info: `Ist die Prüfung des Antrags erfolgreich abgeschlossen, erhalten Sie das von Ihnen zu unterschreibende Vertragsexemplar. Bitte beachten Sie, dass in der Regel weitere Anlagen zum ${ modus.labelVertrag } ausgedruckt werden müssen. Die vollständige Liste wird Ihnen am Antrag im Reiter "Anlagen" angezeigt.`,
          },
        );
      } else {
        this.schritte.push(
          {
            pos: nextPos(),
            titel: `${ modus.labelVertrag } zweimal ausdrucken, unterschreiben und beide Exemplare an das Personaldezernat senden`,
            info: `Ist die Prüfung des Antrags erfolgreich abgeschlossen, erhalten Sie per E-Mail die Information, dass der ${ modus.labelVertrag } durch Sie ausgedruckt werden kann und unterschrieben beim Personaldezernat vorgelegt werden muss (doppelte Ausfertigung!). Bitte beachten Sie, dass in der Regel weitere Anlagen zum ${ modus.labelVertrag } ausgedruckt werden müssen. Die vollständige Liste wird Ihnen am Antrag im Reiter "Anlagen" angezeigt.`,
          },
        );
      }
    }

    if (AntragstellerModus === ASTMODUSKEY.Tarif) {
      this.schritte.push(
        {
          pos: nextPos(),
          titel: `${ modus.labelVertragUnterschrieben || `${ modus.labelVertrag }` } unterschreiben und eine Ausfertigung an das Personaldezernat schicken. Tätigkeit zum vereinbarten Zeitpunkt beginnen`,
          info: `Beachten Sie, dass Sie die Tätigkeit erst dann beginnen dürfen, wenn Sie den durch einen Stellvertreter der Universität unterschriebenen ${ modus.labelVertrag } vorliegen haben.`,
        },
      );
    } else if (AntragstellerModus === ASTMODUSKEY.Vortrag) {
      this.schritte.push(
        {
          pos: nextPos(),
          titel: `Beauftragung durch ${ modus.labelPrüfungsstelleMitArtikel || "das Personaldezernat" }`,
          info: `Ist die Prüfung des Antrags erfolgreich abgeschlossen, erfolgt die Beauftragung durch ${ modus.labelPrüfungsstelleMitArtikel || "das Personaldezernat" }.`,
        },
      );
    } else {
      this.schritte.push(
        {
          pos: nextPos(),
          titel: `${ modus.labelVertragUnterschrieben || `Unterschriebenen ${ modus.labelVertrag }` } erhalten und Tätigkeit beginnen`,
          info: `Beachten Sie, dass Sie die Tätigkeit erst dann beginnen dürfen, wenn Sie den durch einen Stellvertreter der Universität unterschriebenen ${ modus.labelVertrag } vorliegen haben.`,
        },
      );
    }

    console.log(modus)

    return <Panel>
      <h3>Wie reiche ich meinen {modus.labelAntrag} ein?</h3>
      <div>Herzlich Willkommen im e-Portal der Universität Wuppertal.<br /><br />
        {modus.labelWillkommenstext || "Hier haben Sie die Möglichkeit, zu der für Sie vorgesehenen Stellenbesetzung einen Antrag zu erstellen und elektronisch beim Personaldezernat einzureichen."}
        {modus.manualLink && <span> Eine Anleitung zur Antragsannahme erhalten Sie <a href='' onClick={() => this.openDocLink(modus.manualLink)}>hier</a>{modus.manualLinkEn && <span> (<a href='' onClick={() => this.openDocLink(modus.manualLinkEn)}>English version</a>)</span>}.</span>}

        <br /><br />Der gesamte {modus.labelEinstellungsprozess || "Einstellungsprozess"} läuft wie folgt ab:

        <span className='float-end'>
          <Tooltip overlay='Info zu allen Schritten ein-/ausblenden'>
            <Link to='' onClick={this.toggleHilfe} data-message={0} style={{ textDecoration: "none", color: "inherit", fontSize: "larger" }} className='button-link'><Pill className='badge-default'>?</Pill>{`\u00a0`}</Link>
          </Tooltip>
        </span>

      </div>
      <br />

      {_.map(this.schritte, schritt => <Row key={schritt.pos} style={{ paddingBottom: "4px" }}>
        <Col xs={1}><span style={{ fontSize: "larger", textDecoration: "none" }}>
          <Pill className='badge-default'>{schritt.pos}</Pill></span>
        </Col>
        <Col xs={11} style={{ paddingLeft: "8px" }}>
          <Tooltip overlay={`Info zu Schritt ${ schritt.pos } ${ zeigeInfos[schritt.pos] ? "ausblenden" : "einblenden" }`}>
            <Link to='' onClick={this.toggleHilfe} data-message={schritt.pos} style={{ textDecoration: "none", color: "inherit" }} className='button-link'>
              <span style={{ fontSize: "larger", textDecoration: "none" }}>{schritt.titel}</span></Link></Tooltip>
          {zeigeInfos[schritt.pos] && <Panel style={{ marginTop: "8px", marginLeft: "1em" }}>{schritt.info}</Panel>}
        </Col></Row>)}

    </Panel>;
  };

  toggleHilfe = e => {
    e.preventDefault();
    const { zeigeInfos } = this.state;
    const pos = e.currentTarget.getAttribute("data-message");
    if (pos && pos > 0) {
      zeigeInfos[pos] = !zeigeInfos[pos];
      this.setState({ zeigeInfos });
    } else {
      // Alle umschalten
      let status;
      const offene = _.filter(zeigeInfos, s => s == true).length;
      if (offene == this.schritte.length) {
        // Wenn alle geöffnet sind, alle schließen
        status = false;
      } else {
        // Wenn alle geöffnet sind, alle schließen
        status = true;
      }
      _.map(this.schritte, s => zeigeInfos[s.pos] = status);
      this.setState({ zeigeInfos });
    }
  };
}
